exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.editor-wrapper[data-v-57e7e8df] {\n  background-color: white;\n}\n.limit-cell[data-v-57e7e8df] {\n  word-break: break-word;\n}\ntr .key[data-v-57e7e8df] {\n  width: 20%;\n}\ntr .language-content[data-v-57e7e8df] {\n  width: 40%;\n}\n.lang-switch[data-v-57e7e8df] {\n  text-decoration: underline;\n  color: blue;\n  font-size: 12px;\n  margin-right: 5px;\n  cursor: pointer;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-57e7e8df","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./src/components/service/administration/ContentEditor.vue
// module id = DhZj
// module chunks = 53